module.exports = __webpack_public_path__ + "img/step30_a_stand_power_stacker_inser_bars.a2ee53b4.png";